import React, { useCallback, useEffect, useState, useRef } from "react";
import { useError } from "../../context/errorContext";
import CloseIcon from '@mui/icons-material/Close';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import axiosInstance from "../../api/axiosInstance";
import useModalClose from "../../hooks/useModalClose";
import moment from 'moment';

const ChangeLocationPermissions = ({ imei, onClose }) => {
    const [isLoading, setLoading] = useState(true);
    const [permissions, setPermissions] = useState([]);
    const [roles, setRoles] = useState([]);
    const [role, setRole] = useState("");

    const containerRef = useRef(null);

    useModalClose(containerRef, onClose);

    const { showMessage } = useError();

    const fetchData = useCallback(async () => {
        try {
            const [permissionsRes, rolesRes] = await Promise.all([
                axiosInstance.get(`locationpermissions/${imei}`),
                axiosInstance.get(`forms/roles`)
            ]);

            setPermissions(permissionsRes.data);
            setRoles(rolesRes.data);
            setLoading(false);
        } catch (err) {
            console.error(err);
        }
    }, [imei]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleAddPermissions = async (selectedRole) => {
        try {
            await axiosInstance.post(`locationpermissions`, {
                imei,
                roleId: selectedRole
            });

            showMessage("Rechte geändert!");
            setRole("");
            fetchData();
        } catch (err) {
            console.error(err);
            showMessage("Fehler beim Hinzufügen!");
        }
    };

    const handleDeletePermissions = async ({ id }) => {
        try {
            await axiosInstance.delete(`locationpermissions/${id}`);
            showMessage("Rechte entfernt!");
            fetchData();
        } catch (err) {
            console.error("Fehler beim Löschen der Rechte:", err);
            showMessage("Fehler beim Entfernen der Rechte!");
        }
    };

    if (isLoading) return null;

    return (
        <div className="background">
            <div className="modal middle" ref={containerRef}>
                <div className="topBar">
                    <h5>Berechtigungen anpassen</h5>
                    <button className="closeBtn" onClick={onClose}><CloseIcon /></button>
                </div>
                <form onSubmit={(e) => { e.preventDefault(); handleAddPermissions(); }}>
                    {permissions.map((permission) => (
                        <div className="groupList" key={permission.id}>
                            <span className="role">{permission.role}</span>
                            <div className="right">
                                <span>{moment(permission.createdAt).fromNow()}</span>
                                <RemoveCircleOutlineOutlinedIcon onClick={() => handleDeletePermissions(permission)} />
                            </div>
                        </div>
                    ))}
                    <div className="groupInput">
                        <select autoFocus value={role} onChange={(e) => {
                            const selectedRole = e.target.value;
                            setRole(selectedRole);
                            handleAddPermissions(selectedRole);
                        }}
                        >
                            <option value="" disabled hidden>Rolle wählen</option>
                            {roles.map((role) => (
                                <option key={role.name} value={role.id}>{role.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <button onClick={onClose} className="light">Abbrechen</button>
                        </div>
                    </div >
                </form >
            </div>
        </div >
    );
};

export default ChangeLocationPermissions;